export abstract class ServiceBusController {
    // This method is created at runtime when using "watchQuery" decorator from elc-service-bus
    protected registerWatchers: undefined | Function = undefined;

    constructor() {}
}
